import { render } from "./QuizFrameV2.vue?vue&type=template&id=edbd6734&scoped=true"
import script from "./QuizFrameV2.vue?vue&type=script&lang=js"
export * from "./QuizFrameV2.vue?vue&type=script&lang=js"

import "./QuizFrameV2.vue?vue&type=style&index=0&id=edbd6734&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edbd6734"]])

export default __exports__